
<template>
  <Modal
    :id="'cmp-royalty-royalty_accounts-sidewindow-contract_document_template'"
    :loadingFlag="loadingFlag"
    @cancelled="onCancel"
  >
    <template slot="header">Template</template>

    <template slot="body">
      <div class="body-container">
        <SearchList
          :id="'contract-document-templates'"
          :items="bookingtemplates"
          :keyProperty="'booking_template_id'"
          :isSearchable="false"
          :label="'booking_template_name'"
          :selectionNumber="'single'"
          @selected="onRowClicked"
        />
      </div>
      <!-- <div class="body-container" style="margin-top: 30px">
        <table class="dt-table2 contact-table">
          <tbody class="dt-table2--body">
            <tr
              class="dt-table2--row"
              v-for="template in bookingtemplates"
              :key="template.booking_template_id"
              @click="(e) => onRowClicked(template)"
            >
              <td class="dt-table2--column">
                {{ template["booking_template_name"] }}
              </td>
            </tr>
          </tbody>
        </table>
      </div> -->
    </template>

    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">Cancel</button>
    </template>
  </Modal>
</template>

<script>
import { openWindow } from "../../../../utility";
import Modal from "@dtplugins/modal/modal";
import { AccountsService } from "../../services/accounts.service";
import { RoyaltyStoreNamespace as storeNS } from "../../store";
import { mapGetterObject, mapActionObject } from "../../../../store/global";
import { accountsRoyaltyActions } from "../../store/accounts/actions";
import SearchList from "../../../../dt-plugins/search-list/search-list";

export default {
  components: {
    Modal,
    SearchList,
  },
  props: ["selectedAccountDetails"],
  data() {
    return {
      loadingFlag: false,
      bookingtemplates: [],
    };
  },
  mixins: [],
  mounted() {
    this.fetchStatementFormData();
  },
  computed: {
    royalty_account_id: function () {
      return this.$route.params.royalty_account_id;
    },
  },
  methods: {
    ...mapActionObject(storeNS, accountsRoyaltyActions),
    fetchStatementFormData: async function () {
      this.loadingFlag = true;
      const result = await AccountsService.royaltyContractReport({
        royalty_account_id:
          this.selectedAccountDetails?.account?.royalty_account_id,
      });
      this.bookingtemplates = result.data.bookingtemplates;
      this.loadingFlag = false;
    },
    onRowClicked: function (selected) {
      const item = this.bookingtemplates?.find(
        (template) => template.booking_template_id == Array.from(selected)[0]
      );

      const { booking_template_id } = item || {};
      if (!booking_template_id) {
        return;
      }
      openWindow(
        `${HttpClient.getBaseUrl()}/label.pl?section=royalty&action=royalty_contract_report&booking_template_id=${booking_template_id}&royalty_account_id=${
          this.selectedAccountDetails?.account?.royalty_account_id
        }`,
        "Print Invoice",
        { wr: 0.7, hr: 0.7 }
      );
      this.onCancel();
    },
    onCancel: function () {
      this.$emit("cancelled", true);
    },

    onOkClick: async function () {},
  },
};
</script>

<style lang="scss" scoped>
.dt-table2 {
  --body-height: 380px;
  --row-height: 28px;

  display: flex;
  flex-direction: column;

  &--head {
  }
  th.dt-table2--column {
    text-align: left;
    color: #828282;
    font-weight: 400;
  }
  &--body {
    background: #f8f8f8;

    display: flex;
    flex-direction: column;

    border: 1px solid var(--sprt-5);
    border-radius: 3px;

    .dt-table2--row {
      border-bottom: 1px solid var(--sprt-7);
    }

    max-height: var(--body-height);
    overflow: auto;
  }
  &--row {
    display: flex;
    flex-direction: row;
    padding: 5px;
    margin: 0px 10px;

    min-height: var(--row-height);
    cursor: pointer;

    &:hover {
      background: rgb(235, 235, 235);
    }
  }
  &--column {
    flex: 1;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.dt-modal--options {
  button {
    &:first-child {
      margin-right: 10px;
    }
    &:last-child {
      margin-left: 0px 10px;
    }
  }
}
</style>
